import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { S3, WIDGET_ICONS } from "../../../../../../constants";

import submit from "submit-form";
import { isPullActiveCoach } from "../../../../../../utils/user-helpers";
import { getUserToRequest } from "../../../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import WidgetManagerHeader from "./WidgetManagerHeader";
import ImageRadio from "../../../../../../parts/inputs/image-radio";
import { EditWidgetInfoModal } from "../../../../../../parts/modals/EditWidgetInfo";
import SvgIcon from "../../../../../../parts/SvgIcon";
import useCompareState from "../../../../../../hooks/useCompareState";
import { deleteWidgetUtil } from "../../../../../../utils/widgets";

export const MacroCalculator = ({ locals, goBack }) => {
  const { t } = useTranslation("coaching-portal");
  const activeWidget = locals.activeWidget;
  const macroCalculator = locals.macroCalculator;
  const activeUser = locals.activeUser;
  const organizationOwner = locals.organizationOwner;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const referAsClients = activeUser.referAsClients;
  const roleLabel = referAsClients ? t("athletes.roleClients") : t("athletes.roleAthletes");
  //form's state
  const [formState, setFormState] = useState({
    name: "",
    id: "",
    description: "",
    icon: "calculator-icon",
    maintainPercent: 0,
    loseWeightPercent: 0,
    gainWeightPercent: 0,
    maintainProtein: 0,
    maintainCarbs: 0,
    maintainFat: 0,
    loseWeightProtein: 0,
    loseWeightCarbs: 0,
    loseWeightFat: 0,
    gainWeightProtein: 0,
    gainWeightCarbs: 0,
    gainWeightFat: 0,
    pushPermission: true,
    pullPermission: true,
  });

  const [editWidgetInfoModalOpened, setEditWidgetInfoModalOpened] =
    useState(false);

  /**
   * Assign the value for the form's state
   * @param {*} param0
   */
  const handleInputChange = ({ target }) => {
    const targetName = target?.name.replace("-mobile", "") || target?.name;
    const newState = Object.assign({}, formState, {
      [targetName]:
        targetName === "name" ||
        targetName === "description" ||
        targetName === "icon" ||
        target.value === "-" ||
        !target.value
          ? target.value
          : parseInt(target.value),
    });
    setFormState(newState);
    setCurrentCompareState({
      ...compareBase,
      [targetName]: target.value,
    });
  };

  /**
   * Assign the initial values to the form
   */
  const [compareBase, setCompareBase, setCurrentCompareState, hasChanged] =
    useCompareState();
  useEffect(() => {
    if (!!macroCalculator && !!activeWidget) {
      const newStateMacro = Object.assign({}, formState, {
        gainWeightProtein: macroCalculator.gain.proteins
          ? macroCalculator.gain.proteins
          : 0,
        gainWeightCarbs: macroCalculator.gain.carbs
          ? macroCalculator.gain.carbs
          : 0,
        gainWeightFat: macroCalculator.gain.fats
          ? macroCalculator.gain.fats
          : 0,
        gainWeightPercent: macroCalculator.gain.percent
          ? macroCalculator.gain.percent
          : 0,
        loseWeightProtein: macroCalculator.lose.proteins
          ? macroCalculator.lose.proteins
          : 0,
        loseWeightCarbs: macroCalculator.lose.carbs
          ? macroCalculator.lose.carbs
          : 0,
        loseWeightFat: macroCalculator.lose.fats
          ? macroCalculator.lose.fats
          : 0,
        loseWeightPercent: macroCalculator.lose.percent
          ? macroCalculator.lose.percent
          : 0,
        maintainPercent: macroCalculator.maintain.percent
          ? macroCalculator.maintain.percent
          : 0,
        maintainProtein: macroCalculator.maintain.proteins
          ? macroCalculator.maintain.proteins
          : 0,
        maintainCarbs: macroCalculator.maintain.carbs
          ? macroCalculator.maintain.carbs
          : 0,
        maintainFat: macroCalculator.maintain.fats
          ? macroCalculator.maintain.fats
          : 0,
        name: activeWidget.name,
        id: activeWidget._id,
        description: activeWidget.description,
        icon: activeWidget.icon,
        pushPermission:
          activeWidget.pushPermission === undefined
            ? true
            : activeWidget.pushPermission,

        pullPermission:
          activeWidget.pullPermission === undefined
            ? true
            : activeWidget.pullPermission,
      });

      setFormState(newStateMacro);
    }

    if (!!activeWidget && !macroCalculator) {
      const newState = Object.assign({}, formState, {
        name: activeWidget.name,
        id: activeWidget._id,
        description: activeWidget.description,
        icon: activeWidget.icon,
        pushPermission:
          activeWidget.pushPermission === undefined
            ? true
            : activeWidget.pushPermission,

        pullPermission:
          activeWidget.pullPermission === undefined
            ? true
            : activeWidget.pullPermission,
      });
      setFormState(newState);
      setCompareBase(newState);
      setCurrentCompareState(newState);
    }
  }, [activeWidget, macroCalculator]);

  const {
    id,
    description,
    name,
    icon,
    maintainPercent,
    loseWeightPercent,
    gainWeightPercent,
    maintainProtein,
    maintainCarbs,
    maintainFat,
    loseWeightProtein,
    loseWeightCarbs,
    loseWeightFat,
    gainWeightProtein,
    gainWeightCarbs,
    gainWeightFat,
    pushPermission,
    pullPermission,
  } = formState;

  /**
   * Change the icon of the widget
   * @param {*} value
   */
  const handleIconChange = (value) => {
    const newState = Object.assign({}, formState, { icon: value });
    setFormState(newState);
  };

  /**
   * Check id the maintain's form is valid
   * @returns
   */
  const validationMaintain = () => {
    if (maintainCarbs + maintainFat + maintainProtein === 100) {
      return true;
    }
    return false;
  };

  /**
   * Check id the lose weight's form is valid
   * @returns
   */
  const validationLoseWeight = () => {
    if (loseWeightCarbs + loseWeightFat + loseWeightProtein === 100) {
      return true;
    }
    return false;
  };

  /**
   * Check id the gain weight's form is valid
   * @returns
   */
  const validationGainWeight = () => {
    if (gainWeightCarbs + gainWeightFat + gainWeightProtein === 100) {
      return true;
    }
    return false;
  };

  /**
   * Validate if all the forms are valid
   * @returns
   */
  const validationSubmit = () => {
    if (
      validationMaintain() &&
      validationLoseWeight() &&
      validationGainWeight()
    ) {
      return true;
    }
    return false;
  };

  /**
   * Validate if the form to edit the widget is valid
   * @returns
   */
  const validationWidgetSubmit = () => {
    if (description.length > 0 && name.length > 0 && icon.length > 0) {
      return true;
    }
    return false;
  };

  /**
   * Edit a widget
   * @param {*} e
   */
  const handleSubmitEditWidget = (e) => {
    e.preventDefault();
    const body = {
      name: name,
      description: description,
      icon: icon,
      pushPermission: pushPermission,
      pullPermission: pullPermission,
    };

    submit(`/actions/widgets/save/${id}`, {
      method: "POST",
      body: body,
    });
  };

  /**
   * Edit the macro form
   * @param {*} e
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      widget: id,
      maintain: {
        percent: maintainPercent.toString(),
        proteins: maintainProtein.toString(),
        carbs: maintainCarbs.toString(),
        fats: maintainFat.toString(),
      },
      lose: {
        percent: loseWeightPercent.toString(),
        proteins: loseWeightProtein.toString(),
        carbs: loseWeightCarbs.toString(),
        fats: loseWeightFat.toString(),
      },
      gain: {
        percent: gainWeightPercent.toString(),
        proteins: gainWeightProtein.toString(),
        carbs: gainWeightCarbs.toString(),
        fats: gainWeightFat.toString(),
      },
    };
    if (!!macroCalculator) {
      submit(`/actions/macro-calculator/save/${macroCalculator._id}`, {
        method: "POST",
        body: body,
      });
    } else {
      submit(`/actions/macro-calculator/save`, {
        method: "POST",
        body: body,
      });
    }
  };

  /**
   * Delete a widget
   * @param {*} e
   */
  const deleteWidget = (e) => {
    if (!!activeWidget) {
      const { _id } = activeWidget;
      deleteWidgetUtil(e, _id);
    }
  };
  /**
   * Open the edit widget info modal (only for mobile)
   */
  const onOpenEditWidgetInfo = () => {
    setEditWidgetInfoModalOpened(!editWidgetInfoModalOpened);
  };

  /**
   * Control the widget acess
   * @param {*} param0
   * @returns
   */
  const WidgetTogglePush = ({ permission }) => (
    <div className="labeled-switch" sz="large">
      <span>{t("widgets.common.subscriptionsPush")}</span>
        <input
          type="checkbox"
          id="switch-1"
          name="switch-1"
          role="switch"
          onChange={() => {
            const newState = Object.assign({}, formState, {
              pushPermission: !formState.pushPermission,
            });
            setFormState(newState);
            setCurrentCompareState({
              ...compareBase,
              pushPermission: !formState.pushPermission,
            });
          }}
          checked={permission ? true : undefined}
        />
    </div>
  );

  const WidgetTogglePull = ({ permission }) => (
    <div className="labeled-switch" sz="large">
      <span>{t("widgets.common.coachingPull")}</span>
        <input
          type="checkbox"
          id="switch-1"
          name="switch-1"
          role="switch"
          onChange={() => {
            const newState = Object.assign({}, formState, {
              pullPermission: !formState.pullPermission,
            });
            setFormState(newState);
            setCurrentCompareState({
              ...compareBase,
              pullPermission: !formState.pullPermission,
            });
          }}
          checked={permission ? true : undefined}
        />
    </div>
  );
  return (
    <main className="widgets-manager macro-calculator">
      <WidgetManagerHeader
        name={name}
        description={description}
        goBack={goBack}
        onOpenEditWidgetInfo={onOpenEditWidgetInfo}
      />
      <EditWidgetInfoModal
        widgetName={formState.name}
        widgetDescription={formState.description}
        widgetIcon={formState.icon}
        isOpen={editWidgetInfoModalOpened}
        onClose={onOpenEditWidgetInfo}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmitEditWidget}
        validationSubmit={validationWidgetSubmit}
        iconsRadios={WIDGET_ICONS["macro-calculator"]}
        WidgetTogglePull={WidgetTogglePull}
        WidgetTogglePush={WidgetTogglePush}
        userToRequest={userToRequest}
        pullPermission={pullPermission}
        pushPermission={pushPermission}
      />
      <div>
        <aside className="mobile-hidden">
          <div className="overflow-auto max-h-[calc(100vh-16.75rem)]">
            <label>{t("widgets.common.widgetName")}</label>
            <input
              maxLength="30"
              name="name"
              className="text-input"
              placeholder={t("widgets.common.enterName")}
              value={name}
              onChange={handleInputChange}
            />
            <label>{t("widgets.common.widgetDescription")}</label>
            <textarea
              maxLength="60"
              name="description"
              className="text-input"
              placeholder={t("widgets.common.enterDescriptionHere")}
              value={description}
              onChange={handleInputChange}
            />
            <ImageRadio
              label={t("widgets.common.widgetIcon")}
              name="icon"
              currentValue={icon}
              radios={WIDGET_ICONS["macro-calculator"]}
              onChange={handleInputChange}
              isManager={true}
            />
            <label>{t("widgets.common.userTypeAccess")}</label>
            {isPullActiveCoach(userToRequest) && (
              <WidgetTogglePull permission={pullPermission} />
            )}
            {userToRequest.pushAccountInfo && (
              <WidgetTogglePush permission={pushPermission} />
            )}
          </div>
          <footer>
            <button
              data-button-type="secondary"
              data-action="cancel"
              onClick={deleteWidget}
            >
              {t("widgets.common.delete")}
            </button>
            <button
              data-button-type="primary"
              onClick={handleSubmitEditWidget}
              disabled={!hasChanged}
            >
              {t("widgets.common.save")}
            </button>
          </footer>
        </aside>
        <section>
          <header>
            <section className="only-show-mobile back-handler">
              <SvgIcon
                src={"/img/new-icons/back-button.svg"}
                onClickFn={() =>
                  submit(`/actions/refresh/?`, {
                    method: "GET",
                    body: { section: "", learn: "" },
                  })
                }
              />
              <h3>{activeWidget?.name || t("widgets.common.explore")}</h3>
            </section>
            <hgroup className="mobile-hidden">
              <h4>{t("widgets.macroCalculator.title")}</h4>
              <p className="p6">{t("widgets.macroCalculator.configureFormula")}</p>
            </hgroup>
          </header>
          <p className="s1">{t("widgets.macroCalculator.formula")}</p>
          <p className="p1">{t("widgets.macroCalculator.step1", { role: roleLabel })}</p>

          <p className="p1">{t("widgets.macroCalculator.step2")}</p>

          <p className="p1">{t("widgets.macroCalculator.step3")}</p>
          <p className="p1">{t("widgets.macroCalculator.step4", { role: roleLabel })}</p>
          <p className="p1">{t("widgets.macroCalculator.step5")}</p>

          <p className="p1">{t("widgets.macroCalculator.step6")}</p>
          <h4>{t("widgets.macroCalculator.formulaVariables")}</h4>
          <article className="formula-variable-wrapper">
            <header>
              <p className="s1">1</p>
              <hgroup>
                <p className="s1">{t("widgets.macroCalculator.calorieTargetByGoal")}</p>
                <p className="p6">{t("widgets.macroCalculator.assignPercentHint")}</p>
              </hgroup>
            </header>

            <table>
              <tbody>
                <tr>
                  <th></th>
                  <th className="identifier-table-macro">{t("widgets.macroCalculator.deficitSurplus")}</th>
                </tr>
                <tr>
                  <td className="title-table-macro">{t("widgets.macroCalculator.maintain")}</td>
                  <td>
                    <div className="suffix-input-container">
                      <input
                        type="number"
                        name="maintainPercent"
                        className="text-input-macro"
                        value={maintainPercent}
                        onChange={handleInputChange}
                        sz="large"
                      />
                      <span className="load-suffix">%</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="title-table-macro">{t("widgets.macroCalculator.loseWeight")}</td>
                  <td>
                    <div className="suffix-input-container">
                      <input
                        type="number"
                        name="loseWeightPercent"
                        className="text-input-macro"
                        value={loseWeightPercent}
                        onChange={handleInputChange}
                        sz="large"
                      />
                      <span className="load-suffix">%</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="title-table-macro">{t("widgets.macroCalculator.gainWeight")}</td>
                  <td>
                    <div className="suffix-input-container">
                      <input
                        type="number"
                        name="gainWeightPercent"
                        className="text-input-macro"
                        value={gainWeightPercent}
                        onChange={handleInputChange}
                        sz="large"
                      />
                      <span className="load-suffix">%</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </article>
          <article className="formula-variable-wrapper">
            <header>
              <p className="s1">2</p>
              <hgroup>
                <p className="s1">{t("widgets.macroCalculator.macroSplitByGoal")}</p>
                <p className="p6">{t("widgets.macroCalculator.assignMacroSplitHint")}</p>
              </hgroup>
            </header>
            <div>
              <table>
                <tbody>
                <tr>
                  <th></th>
                  <th className="identifier-table-macro">{t("widgets.macroCalculator.protein")}</th>
                  <th className="identifier-table-macro">{t("widgets.macroCalculator.carbs")}</th>
                  <th className="identifier-table-macro">{t("widgets.macroCalculator.fat")}</th>
                  <th></th>
                </tr>
                <tr>
                  <td className="title-table-macro">{t("widgets.macroCalculator.maintain")}</td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="maintainProtein"
                          className="text-input-macro"
                          value={maintainProtein}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="maintainCarbs"
                          className="text-input-macro"
                          value={maintainCarbs}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="maintainFat"
                          className="text-input-macro"
                          value={maintainFat}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      {validationMaintain() ? (
                        <div className="chip success">{t("widgets.macroCalculator.done")}</div>
                      ) : (
                        <div className="chip info">{t("widgets.macroCalculator.total100Required")}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="title-table-macro">{t("widgets.macroCalculator.loseWeight")}</td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="loseWeightProtein"
                          className="text-input-macro"
                          value={loseWeightProtein}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="loseWeightCarbs"
                          className="text-input-macro"
                          value={loseWeightCarbs}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="loseWeightFat"
                          className="text-input-macro"
                          value={loseWeightFat}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      {validationLoseWeight() ? (
                        <div className="chip success">{t("widgets.macroCalculator.done")}</div>
                      ) : (
                        <div className="chip info">{t("widgets.macroCalculator.total100Required")}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="title-table-macro">{t("widgets.macroCalculator.gainWeight")}</td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="gainWeightProtein"
                          className="text-input-macro"
                          value={gainWeightProtein}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="gainWeightCarbs"
                          className="text-input-macro"
                          value={gainWeightCarbs}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="suffix-input-container">
                        <input
                          type="number"
                          sz="large"
                          name="gainWeightFat"
                          className="text-input-macro"
                          value={gainWeightFat}
                          onChange={handleInputChange}
                        />
                        <span
                          className={
                            !validationGainWeight() ||
                            !validationLoseWeight() ||
                            !validationMaintain()
                              ? "load-suffix error-percentage-macro"
                              : "load-suffix success-percentage-macro"
                          }
                        >
                          %
                        </span>
                      </div>
                    </td>
                    <td>
                      {validationGainWeight() ? (
                        <div className="chip success">{t("widgets.macroCalculator.done")}</div>
                      ) : (
                        <div className="chip info">{t("widgets.macroCalculator.total100Required")}</div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </article>
          <button
            data-button-type="primary"
            onClick={handleSubmit}
            disabled={!validationSubmit()}
          >
            {t("widgets.common.save")}
          </button>
        </section>
      </div>
    </main>
  );
};
